export default __webpack_public_path__ + "static/media/onboarding-support.2b27eb25.jpg";